import axios from "axios";
import { apiUrl } from "./env";

const apiHealthInstance = axios.create({
  baseURL: apiUrl,
  timeout: 10000,
});

const apiHealthService = {
  getArticles(userToken, { resultsPerPage, actualPage, order, status, query }) {
    return apiHealthInstance({
      method: "GET",
      url: `/article?product=15&limit=${resultsPerPage}&page=${actualPage}${order}${status}${query}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  getArticleById(userToken, id) {
    return apiHealthInstance({
      method: "GET",
      url: `/article/detail?id=${id}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  createArticle(userToken, data) {
    return apiHealthInstance({
      method: "POST",
      url: "/article?product=15",
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },
  setArticle(userToken, data) {
    return apiHealthInstance({
      method: "PUT",
      url: "/article?product=15",
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },
  deleteArticle(userToken, ids) {
    return apiHealthInstance({
      method: "DELETE",
      url: "/article",
      headers: {
        Authorization: userToken,
      },
      data: { idList: ids },
    });
  },
  getRelatedArticle(userToken, articleId) {
    return apiHealthInstance({
      method: "GET",
      url: `/article/related?articleId=${articleId}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  setRelatedArticle(userToken, articleId, relatedId) {
    return apiHealthInstance({
      method: "POST",
      url: "/article/related",
      headers: {
        Authorization: userToken,
      },
      data: {
        articleId,
        relatedId,
      },
    });
  },
  deleteRelatedArticle(userToken, articleId, relatedId) {
    return apiHealthInstance({
      method: "DELETE",
      url: "/article/related",
      headers: {
        Authorization: userToken,
      },
      data: {
        articleId,
        relatedId,
      },
    });
  },
  relatedSearchArticle(userToken, query, articleId) {
    return apiHealthInstance({
      method: "GET",
      url: `/article/related/search?query=${query}&id=${articleId}`,
      headers: {
        Authorization: userToken,
      },
    });
  },

  // banners methods
  getBanners(userToken) {
    return apiHealthInstance({
      method: "GET",
      url: `/banner`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  getBannerById(userToken, id) {
    return apiHealthInstance({
      method: "GET",
      url: `/banner/${id}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  createBanner(userToken, data) {
    return apiHealthInstance({
      method: "POST",
      url: "/banner",
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },
  setBanner(userToken, bannerId, data) {
    return apiHealthInstance({
      method: "PUT",
      url: `/banner/${bannerId}`,
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },
  deleteBanner(userToken, ids) {
    return apiHealthInstance({
      method: "DELETE",
      url: "/banner",
      headers: {
        Authorization: userToken,
      },
      data: { idList: ids },
    });
  },
  getAppAreas(userToken) {
    return apiHealthInstance({
      method: "GET",
      url: "/banner/area",
      headers: {
        Authorization: userToken,
      },
    });
  },
  getAppAreaById(userToken, areaId) {
    return apiHealthInstance({
      method: "GET",
      url: `/banner/area/${areaId}`,
      headers: {
        Authorization: userToken,
      },
    });
  },

  // theme methods
  getThemes(userToken, page = 1, limit = 10) {
    return apiHealthInstance({
      method: "GET",
      url: `/theme/?product=15&page=${page}&limit=${limit}`,
      headers: {
        Authorization: userToken,
      },
    });
  },

  // author methods
  getAuthors(userToken, page = 1, limit = 10) {
    return apiHealthInstance({
      method: "GET",
      url: `/author/?page=${page}&limit=${limit}`,
      headers: {
        Authorization: userToken,
      },
    });
  },

  // tags
  getTags(userToken, tag = "") {
    return apiHealthInstance({
      method: "GET",
      url: `/tag?query=${tag}`,
      headers: {
        Authorization: userToken,
      },
    });
  },

  // faq methods
  getFaqById(userToken, productId) {
    return apiHealthInstance({
      method: "GET",
      url: `/faq?productId=${productId}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  getFaqItemById(userToken, itemId) {
    return apiHealthInstance({
      method: "GET",
      url: `/faq/detail/${itemId}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  createFaqItem(userToken, data) {
    return apiHealthInstance({
      method: "POST",
      url: "/faq/",
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },
  setFaqItem(userToken, data) {
    return apiHealthInstance({
      method: "PUT",
      url: "/faq/",
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },
  deleteFaqItem(userToken, ids) {
    return apiHealthInstance({
      method: "DELETE",
      url: "/faq/",
      headers: {
        Authorization: userToken,
      },
      data: { idList: ids },
    });
  },

  // terms methods
  getTermById(userToken, productId) {
    return apiHealthInstance({
      method: "GET",
      url: `/terms?productId=${productId}`,
      headers: {
        Authorization: userToken,
      },
    });
  },
  setTerm(userToken, data) {
    return apiHealthInstance({
      method: "PUT",
      url: "/terms/",
      headers: {
        Authorization: userToken,
      },
      data,
    });
  },

  // professions
  // =================================================

  getProfessions(
    userToken,
    { resultsPerPage, actualPage, status = "", query = "", orderType, order }
  ) {
    const filterParam = status ? `&filter=${status}` : "";
    const queryParam = query ? `&query=${query}` : "";
    const orderTypeParam = orderType ? `&order_type=${orderType}` : "";
    const orderParam = order ? `&order=${order}` : "";

    return apiHealthInstance({
      method: "GET",
      url: `/profession?limit=${resultsPerPage}&page=${actualPage}${filterParam}${queryParam}${orderTypeParam}${orderParam}`,
      headers: { Authorization: userToken },
    });
  },

  getProfessionById(userToken, id) {
    return apiHealthInstance({
      method: "GET",
      url: `/profession/detail/${id}`,
      headers: { Authorization: userToken },
    });
  },

  createProfession(userToken, data) {
    return apiHealthInstance({
      method: "POST",
      url: "/profession/create",
      headers: { Authorization: userToken },
      data,
    });
  },

  setProfession(userToken, id, data) {
    return apiHealthInstance({
      method: "PUT",
      url: `/profession/update/${id}`,
      headers: { Authorization: userToken },
      data,
    });
  },

  deleteProfession(userToken, ids) {
    return apiHealthInstance({
      method: "DELETE",
      url: "/profession/",
      headers: { Authorization: userToken },
      data: { idList: ids },
    });
  },

  // app versions
  getVersions(token, productId) {
    const product = productId ? `?product_id=${productId}` : "";
    return apiHealthInstance({
      method: "GET",
      url: `/version${product}`,
      headers: { Authorization: token },
    });
  },

  getVersionById(token, id) {
    return apiHealthInstance({
      method: "GET",
      url: `/version/detail/${id}`,
      headers: { Authorization: token },
    });
  },

  // createVersion (token, data) {
  //   return apiHealthInstance({
  //     method: 'POST',
  //     url: '/version/create',
  //     headers: { Authorization: token },
  //     data
  //   })
  // },

  setVersion(token, id, data) {
    return apiHealthInstance({
      method: "PUT",
      url: `/version/detail/${id}`,
      headers: { Authorization: token },
      data,
    });
  },

  // deleteVersion (token, id, data) {
  //   return apiHealthInstance({
  //     method: 'DELETE',
  //     url: `/version/delete/${id}`,
  //     headers: { Authorization: token },
  //     data
  //   })
  // }
};

export default {
  install(Vue) {
    Vue.$apiHealthService = apiHealthService;
    Vue.prototype.$apiHealthService = apiHealthService;
  },
};



// WEBPACK FOOTER //
// ./src/services/health.js